import { fetcher } from "utils";

export const post__users__products = (params: { productId: string | number }): Promise<" "> =>
  fetcher.post("/users/products", params);
